/**
 * Created by Jie Gao on 05/24/2019.
 */

import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {DragonTribeGameAssets} from "../DragonTribeGameAssets";
import {DTReelSymbol} from "./DTReelSymbol";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export class DTReelSymbolMystery extends DTReelSymbol {

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    public updateBackground(symHeight:number):void {
        super.updateBackground(symHeight);
        const scale:number = MathHelper.roundToDecimals(symHeight/250,2);
        this._symBackground.texture = GameResources.getTextures(DragonTribeGameAssets.MYS_BG)[0];
        this._symBackground.scale.y = scale;
    }
}